import { render, staticRenderFns } from "./CollectionsTopNav.vue?vue&type=template&id=1a2c6cbc&scoped=true"
import script from "./CollectionsTopNav.vue?vue&type=script&lang=js"
export * from "./CollectionsTopNav.vue?vue&type=script&lang=js"
import style0 from "./CollectionsTopNav.vue?vue&type=style&index=0&id=1a2c6cbc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a2c6cbc",
  null
  
)

export default component.exports